define(['angular'], function(angular) {


    /**
     * @class ContractTypeService
     */
    function ContractTypeService() {
        var self = this;
        var contractTypes = [];

        self.initContractTypes = function initContractTypes(orderForm) {
            contractTypes = orderForm.contractTypes;
        };

        self.getContractTypeByCode = function getContractTypeByCode(contractTypeCode) {
            return contractTypes.find(function(contractType) {
                return contractType.code === contractTypeCode;
            });
        };

        return self;
    }

    ContractTypeService.$inject = [];

    angular.module('app.bdc.common.contractTypeService', []).factory('contractTypeService', ContractTypeService);
});
